<template>
    <div>
        <div class="mb-2 flex items-start justify-between">
            <span class="font-bold">{{ $t('document_id') }}:</span>
            <span>{{ modelValue.id }}</span>
        </div>
        <div class="flex items-start justify-between">
            <span class="font-bold">{{ $t('file') }}:</span>
            <a
                :href="(modelValue.url as string)"
                target="_blank"
                class="text-blue-500"
            >
                {{ $t('open_doc_in_new_tab') }}
            </a>
        </div>
    </div>

    <div>
        <SelectField
            v-model="modelValue.ecsp_status"
            name="ecsp_status"
            label="ecsp_status"
            help="help_ecsp_status"
            :options="mapEnumToArray(EcspStatusType)"
            :reduce="reduceEnumValue"
            :required="true"
        />
    </div>
    <div>
        <TextField
            v-model="modelValue.verification_comment"
            label="comment"
            name="verification_comment"
            :rows="4"
            help="help_comment"
        />
    </div>
</template>
<script setup lang="ts">
import { useEnum } from '@composables/common'
import { SelectField, TextField } from '@src/components'
import { EcspStatusType } from '@src/enums'
import { ECSPDocument } from '@src/types'
import { Ref, toRefs } from 'vue'

const props = defineProps<{ modelValue: Ref<ECSPDocument> }>()

const { modelValue } = toRefs(props)
const { mapEnumToArray, reduceEnumValue } = useEnum()
</script>
